import type { IntlShape } from "@formatjs/intl";
import { Skeleton } from "antd";
import type { HookAPI } from "antd/es/modal/useModal";
import { connect, type DispatchProp } from "react-redux";
import type { State as RouterState } from "router5";
import ConnectedAppLayout from "../../AppLayout";
import type { RootState } from "../../store";
import type { SideloadedTicketInfo } from "../../../features/ticket/ticketSlice";
import type { SideloadedTurbineInfo } from "../../../features/turbine/turbineSlice";
import type {
	Client,
	PaginatedticketResultsSideloadList,
	PaginatedturbineResultsSideloadList,
	Project,
	Services,
} from "../../generated-axios-client";
import { ClientViewRender } from "./ClientViewRender";

export type ClientViewProps = {
	intl: IntlShape<string>;
	currentRoute: RouterState | null;
	client: Client | null;
	tickets: PaginatedticketResultsSideloadList;
	ticketSideload: SideloadedTicketInfo | null;
	turbines: PaginatedturbineResultsSideloadList;
	turbineSideload: SideloadedTurbineInfo | null;
	serviceObjects: Record<string, Services> | null;
	clientProjects: Project[];
	modalApi: HookAPI | undefined;
};

type ClientViewPageProps = ClientViewProps & DispatchProp;

const ClientView = (props: ClientViewPageProps) => {
	const {
		intl,
		currentRoute,
		modalApi,
		client,
		tickets,
		turbines,
		ticketSideload,
		turbineSideload,
		serviceObjects,
		clientProjects,
		dispatch,
	} = props;

	if (!client || !ticketSideload || !turbineSideload) {
		return <Skeleton active />;
	}

	const clientData = {
		client,
		tickets,
		turbines,
		ticketSideload,
		turbineSideload,
		serviceObjects,
		clientProjects,
	};

	return (
		<ConnectedAppLayout>
			<ClientViewRender
				intl={intl}
				currentRoute={currentRoute}
				clientData={clientData}
				modalApi={modalApi}
				dispatch={dispatch}
			/>
		</ConnectedAppLayout>
	);
};

const withClientView = (state: RootState) => ({
	client: state.client.client,
	tickets: state.ticket.list,
	ticketSideload: state.ticket.sideload,
	turbines: state.turbine.list,
	turbineSideload: state.turbine.sideload,
	serviceObjects: state.ticket.servicesObj,
	clientProjects: state.project.clientProjects,
	currentRoute: state.router.route,
	intl: state.intl.datetimeIntl,
	modalApi: state.appFeedback.modal,
});
export const ConnectedClientViewPage = connect(withClientView)(ClientView);

export default ConnectedClientViewPage;
